"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidModelTypeId = exports.ModelClassList = void 0;
const tslib_1 = require("tslib");
const ModelClasses = tslib_1.__importStar(require("../model"));
const ModelClassList = Object.keys(ModelClasses);
exports.ModelClassList = ModelClassList;
const isValidModelTypeId = (objectTypeId) => ModelClassList.includes(objectTypeId);
exports.isValidModelTypeId = isValidModelTypeId;
